import { create } from "zustand";
import {message} from "antd";

import axios from "../helper/axios";

const useRDBStore = create((set) => ({
    rdbPageResult:null,
    rdbRefreshResult:false,
    rdbLinkStatusInfo:null,
    rdbLinkUserMetaData:null,
    
    rdbResumeSearchPerPage: async (body,duration) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log("rdbResumeSearchPerPage",body);
            const response = await axios.post(
                `/rdbsearch/${userData.qhoid}/${userData.qhuid}/${duration}`,
                body
            );
            set({ rdbPageResult: response.data.searchResp });
            set({ rdbRefreshResult: true});
            set({ rdbLinkUserMetaData: response.data.usermetadata });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    }, 
    resetRdbResumeSearchFlag: async () => {
        set({ rdbPageResult: null });
    },
    resetRdbRefreshResults: async () => {
        set({ rdbRefreshResult: false });
    },   
    rdbLinkResumetoJD: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/rdbsearchLinkJD/${userData.qhoid}/${userData.qhuid}`,
                body
            );
            var responseData = response.data.data
            //console.log(response.data);
            if(responseData.status === "DUPLICATE_UPLOADED_VENDOR"){
                message.success(`Duplicate, Uploaded by Another Vendor`);
            }else if(responseData.status === "DUPLICATE_UPLOADED_TEAM"){
                message.success(`Duplicate, Already Assigned to this JD`);
            }else if(responseData.status === "DUPLICATE_UPLOADED_JOBSEARCH"){
                message.success(`Duplicate, Already Assigned to this JD`);
            }else if(responseData.status === "DUPLICATE_UPLOADED_CAREERPAGES"){
                message.success(`Duplicate, Already Assigned to this JD`);
            }else if(responseData.status === "DUPLICATE_UPLOADED_FORMLINK"){
                message.success(`Duplicate, Already Assigned to this JD`);
            }else{
                message.success(`Linked successfully`);
            }  
            set({ rdbLinkStatusInfo: responseData });
            set({ rdbLinkUserMetaData: response.data.usermetadata });
                      
        } catch (error) {
            set({ jdCreationError: error });
        }
    }, 
    rdbLinkHistoryClean: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/rdbLinkHistoryClean/${userData.qhoid}/${userData.qhuid}`
            );
            set({ rdbLinkUserMetaData: null });
                      
        } catch (error) {
            set({ jdCreationError: error });
        }
    }, 
    rdbUpdateSkills: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/rdbsearchKeywordChange/${userData.qhoid}/${userData.qhuid}}`,
                body
            );
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },
    rdbSearchSyncULMetaData: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const pendingRDBMetaData = JSON.parse(localStorage.getItem("pendingRDBMetaData"))
            //console.log(pendingRDBMetaData);
            const response = await axios.post(
                `/rdbsearchSyncULMetaData/${userData.qhoid}/${userData.qhuid}}`,
                pendingRDBMetaData
            );
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },        
    resetLinkStatusInfo: () => {
        set({ rdbLinkStatusInfo: null });
    },                                     
}));

export default useRDBStore;
